import { useState, useCallback } from "react";

export function useToast() {
  const [ts, setTs] = useState([]);
  const show = useCallback((msg, type = "success") => {
    const id = Date.now() + Math.random();
    setTs((t) => [...t, { id, msg, type }]);
    setTimeout(() => setTs((t) => t.filter((x) => x.id !== id)), 3500);
  }, []);
  return { ts, show };
}

export function Toasts({ ts }) {
  if (!ts || ts.length === 0) return null;
  const bg = {
    success: "#14532d",
    error: "#7f1d1d",
    warning: "#78350f",
  };
  const border = {
    success: "#22c55e55",
    error: "#ef444455",
    warning: "#f59e0b55",
  };
  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      {ts.map((t) => (
        <div
          key={t.id}
          style={{
            background: bg[t.type] || bg.success,
            color: "#fff",
            borderRadius: 10,
            padding: "12px 20px",
            fontSize: 14,
            fontWeight: 600,
            border: `1px solid ${border[t.type] || border.success}`,
            boxShadow: "0 8px 32px #000a",
          }}
        >
          {t.msg}
        </div>
      ))}
    </div>
  );
}
